import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { isNullOrEmpty } from '../../../../../utils/vuex';
export default {
  name: 'CoreDtwinStateBridgeMqtt',
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: true
    },
    // is this an 'edit', 'create', or mass-variable- 'import'?
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    }
  },
  data: function data() {
    return {
      deviceIdentifier: null,
      parsedPacketVariable: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    formIsValid: function formIsValid() {
      return !isNullOrEmpty(this.deviceIdentifier);
    }
  }),
  watch: {
    parsedPacketVariable: function parsedPacketVariable() {
      this.emitSelection();
    },
    deviceIdentifier: function deviceIdentifier() {
      this.emitSelection();
    }
  },
  created: function created() {
    if (this.mode !== 'create' && this.mode !== 'import') {
      this.deviceIdentifier = this.lclModel.properties.binding.options.identifier;
      this.parsedPacketVariable = this.lclModel.properties.binding.options.variable;
    }
  },
  methods: {
    emitSelection: function emitSelection() {
      this.$emit('bridge-binding-changed', {
        variable: this.parsedPacketVariable
      });
    },
    saveState: function saveState() {
      this.lclModel.properties.binding.options.identifier = this.deviceIdentifier;
      this.lclModel.properties.binding.options.variable = this.parsedPacketVariable;
    }
  }
};